import axios from 'axios';
import keycloak from '../keycloak';

// Konfiguracja seryjnego przesyłania parametrów tablicowych (bez nawiasów [], np. tags=c&tags=d)
const axiosConfig = {
    paramsSerializer: {
        indexes: null,
    }
};

const noteApi = axios.create({
    baseURL: '/backend/api/notes',
    ...axiosConfig
});

const searchApi = axios.create({
    baseURL: '/backend/api/search',
    ...axiosConfig
});

const fileApi = axios.create({
    baseURL: '/backend/api/files',
    ...axiosConfig
});

const publicApi = axios.create({
    baseURL: '/backend/api/public',
    ...axiosConfig
});

const aiApi = axios.create({
    baseURL: '/backend/api/ai',
    timeout: 300000,
    ...axiosConfig
});

const addAuthInterceptor = (instance) => {
    instance.interceptors.request.use((config) => {
        if (keycloak.token) {
            config.headers.Authorization = `Bearer ${keycloak.token}`;
        }
        return config;
    });
};

addAuthInterceptor(noteApi);
addAuthInterceptor(searchApi);
addAuthInterceptor(fileApi);
addAuthInterceptor(aiApi);

export { noteApi, searchApi, fileApi, publicApi, aiApi };
